import { Component, input, output } from '@angular/core';
import { KENDO_DIALOGS } from '@progress/kendo-angular-dialog';
import { ActionsLayout } from '@progress/kendo-angular-layout';

@Component({
  selector: 'unity-dialog-shared',
  standalone: true,
  imports: [KENDO_DIALOGS],
  templateUrl: './dialog-shared.component.html',
  styleUrl: './dialog-shared.component.scss',
})
export class DialogSharedComponent {
  public readonly $title = input.required<string | undefined>({ alias: 'title' });

  public readonly $width = input<string>('500px', { alias: 'width' });
  public readonly $height = input<string>('auto', { alias: 'height' });
  public readonly $layout = input<ActionsLayout>('stretched', { alias: 'layout' });

  public readonly closeEvent = output();

  protected onClose() {
    this.closeEvent.emit();
  }
}
